"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxOptionLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * @since 8.28.0
 */
var ListboxOptionLabel = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "ListboxOptionLabel",
  componentId: "c11n-8-107-0__sc-11c6ubi-0"
})([""]);
exports.ListboxOptionLabel = ListboxOptionLabel;
ListboxOptionLabel.displayName = 'ListboxOptionLabel';

/** @component */